module.exports = __webpack_public_path__ + "static/media/fidelizacion.19284c33.svg";